export enum moduleName {
  CLIENT = 'USER',
  INTERNAL_USER = 'INTERNALUSER',
  CONTENT_CONTRIBUTOR = 'CONTENTCONTRIBUTOR',
  INSTITUTION = 'INSTITUTION',
  INSTITUTION_STOCK_PLACEMENT = 'INSTITUTION_STOCK_PLACEMENT',
  INSTITUTION_CONTENT = 'INSTITUTIONCONTENT',
  CIRCLE_RESEARCH = 'COMMUNITYRESEARCH',
  ALGO_RESEARCH = 'ALGORESEARCH',
  ALGO_NEWS = 'ALGONEWS',
  RESEARCH_RELATED_TAG = 'RESEARCHRELATEDTAG',
  NEWS_RELATED_TAG = 'NEWSRELATEDTAG',
  MASTER_RESEARCH_TAG = 'MASTERRESEARCHTAG',
  USER_PERMISSION = 'USERPERMISSION',
  RESEARCH_CATEGORY = 'RESEARCHCATEGORY',
  NEWS_LETTER = 'NEWSLETTER',
  ALGO_RESEARCH_BLAST = 'ALGORESEARCHBLAST',
  // STOCK_INDEX = 'STOCKINDEX',
  HYBRID_SLIDER = 'HYBRIDSLIDER',
  META_HYBRID_SLIDER = 'METADATAHYBRIDSLIDER',
  MASTER_STOCK_INDEX = 'MASTERSTOCKINDEX',
  INDEX_EDITOR = 'STOCKDATA',
  STOCK_PLACEMENT = 'MASTERSTOCK',
  TEXT_SLIDER = 'TEXTSLIDER',
  SUBSCRIPTION = 'SUBSCRIPTION',
  SUBSCRIPTION_MODULE = 'SUBSCRIPTION_MODULE',
  INSTITUTION_ANALYTIC = 'INSTITUTIONANALYTIC',
  ALGO_RESEARCH_ANALYTIC = 'ALGORESEARCHANALYTIC',
  CIRCLE_ANALYTIC = 'CIRCLEANALYTIC',
  ALGO_NEWS_ANALYTIC = 'ALGONEWSANALYTIC',
  USER_ANALYTIC='USERANALYTIC',
  AD_BANNER='ADBANNER',
  PUBLIC_API='PUBLICAPI',
  STANDUP='STANDUP',
  ACCOUNT_WALL = 'ACCOUNTWALL',
  CIRCLE_DISCLOSURE = 'CIRCLEDISCLOSURE',
  CONTRIBUTORCMS_CIRCLE_RESEARCH = 'CONTRIBUTORCMSCIRCLERESEARCH',
  LEGAL_INFORMATION = 'LEGALINFORMATION',
  SUBSCRIPTION_TRANSACTION = 'SUBSCRIPTION_TRANSACTION',
  SUBSCRIPTION_PROMO_DISCOUNT = 'SUBSCRIPTION_PROMO_DISCOUNT',
  ATTENDANCE = 'ATTENDANCE',
  STOCK_SENTIMENT = 'STOCK_SENTIMENT',
  MEDIA_EMBEDS = 'MEDIA_EMBEDS',
  CHART_SETTING = 'CHART_SETTING',
  MASTER_CONTENT_PRICE = 'MASTER_CONTENT_PRICE',
  PURCHASE_PROMO_DISCOUNT = 'PURCHASE_PROMO_DISCOUNT',
  USER_CONTENT_PURCHASE = 'USER_CONTENT_PURCHASE',
  STOCK_CODE_LIST = 'STOCKCODELIST',
  STREETCALL_CONTENT = 'STREETCALLCONTENT',
  FUND_FACT_SHEET_CONTENT = 'FUNDFACTSHEETCONTENT',
  PUBLIC_COMPANY_INFORMATION = 'PUBLICCOMPANYINFORMATION',
  STOCK_SUMMARY = 'STOCKSUMMARY',
  MARKETDATA_SOURCE = 'MARKETDATASOURCE',
  MARKETDATA_SORTORDER = 'MARKETDATASORTORDER',
}
export enum accessName {
  READ = 'read',
  WRITE = 'write',
  UPDATE = 'update',
  DELETE = 'delete',
  APPROVAL = 'approval'
}
